<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["settings", "user"]),
  },
  async created() {
    const lang = localStorage.getItem("lang") || "en";
    this.$i18n.locale = lang;
    if (localStorage.getItem("lang") == null) {
      window.templateCustomizer.setLang("ar");
      window.templateCustomizer.setRtl(true);
      localStorage.setItem("lang", "ar");
      window.templateCustomizer.setStyle("light");
    }
  },
  methods: {},
};
</script>
